/* eslint-disable no-prototype-builtins */
import { isEmpty } from 'lodash';
import { PAD_VISIT_TYPE } from 'app/config/padVisits';
import { USER_TYPE } from 'app/config/users';
import { VISITATION_TYPE_TEMPLATE } from 'app/config/visitationTypeTemplate';
import { CBOCODE } from 'app/config/profession';
import { FREQUENCY } from 'app/config/frequency_type';
import { codeGeneretor } from 'app/utils';
import { DailySchedule } from 'app/redux/reducers/initialize-pad/dailySchedule/DailySchedule';
import _ from 'lodash';
import { REPETITION } from 'app/redux/actions/initialize-pad/initialize-pad.action';

const TEMPLATE_NAME = 'INITIALIZE_PAD';

const updateRepetition = ({ padVisit, genericVisit, repetition }) => {
  return genericVisit.map(visit => {
    if (visit.padVisit.id === padVisit.id) {
      visit.events = [];
      visit.isMaximumVisitsScheduled = false;
      visit.repetition = repetition;

      return visit;
    } else {
      return visit;
    }
  });
};

// const updateAutomaticRepeat = (cPadVisit, genericVisit) => {
//   return genericVisit.map(visit => {
//     const { padVisit } = visit;

//     if (padVisit.id === cPadVisit.id) {
//       // visit.events = [];
//       const toggledRepeat = !visit.automaticRepeat;
//       visit.automaticRepeat = toggledRepeat;
//       if (toggledRepeat) {
//         visit.dailyAutomaticRepeat = false;
//       }

//       return visit;
//     } else {
//       return visit;
//     }
//   });
// };

// const dailyUpdateAutomaticRepeat = (cPadVisit, genericVisit) => {
//   return genericVisit.map(visit => {
//     const { padVisit } = visit;

//     if (padVisit.id === cPadVisit.id) {
//       const toggledRepeat = !visit.dailyAutomaticRepeat;
//       visit.dailyAutomaticRepeat = toggledRepeat;
//       if (toggledRepeat) {
//         visit.automaticRepeat = false;
//       }

//       return visit;
//     } else {
//       return visit;
//     }
//   });
// };

const clearSchedule = (cPadVisit, genericVisit) => {
  return genericVisit.map(visit => {
    const { padVisit } = visit;

    if (padVisit.id === cPadVisit.id) {
      return {
        ...visit,
        events: [],
        isMaximumVisitsScheduled: false,
        repetition: REPETITION.NONE
        // automaticRepeat: false,
        // dailyAutomaticRepeat: false,
      };
    } else {
      return visit;
    }
  });
};

const updateScheduledMaximumVisits = (cPadVisit, genericVisit, isMaximumVisitsScheduled) => {
  return genericVisit.map(visit => {
    const { padVisit } = visit;

    if (padVisit.id === cPadVisit.id) {
      visit.isMaximumVisitsScheduled = isMaximumVisitsScheduled;

      return visit;
    } else {
      return visit;
    }
  });
};

const checkDailySchedule = padVisit => {
  const { frequencyId, profession } = padVisit;

  // técnico de enfermagem (322205)
  const isProfessionNursingTechnician = profession.CBOCode === CBOCODE.NURSING_TECHNICIAN;
  //  frequência "vezes por dia"
  const isDailyFrequency = frequencyId === FREQUENCY.DAY_ID;

  return isProfessionNursingTechnician && isDailyFrequency;
};

const buildDailyScheduleFormVisit = () => {
  const code = codeGeneretor();
  return {
    code,
    professionalName: null,
    periodsForVisit: [],
    periodsForRest: [],

    formVisits: {
      code,
      professionalId: null,
      startDate: null,
      workSchedule: null,
      period: null,
      workShift: null,
      selectionCompleted: 0
    }
  };
};

const buildDailyScheduleObj = padVisit => {
  return {
    padVisit,
    errors: [],
    isScheduleComplete: false,
    visitScheduleReference: [],
    scheduleReport: [],
    scheduleErrors: {
      detailedErrors: [],
      summaryErrors: []
    },
    schedulePendings: {
      detailedPendings: [],
      summaryPendings: []
    },
    schedulingEvents: [buildDailyScheduleFormVisit()]
  };
};

/**
 * This function builds the initial array of data selected ti client.
 *
 */
const initialArrayOfClientVisits = pad => {
  const padVisits = pad.padVisits;
  const genericVisit = [];
  const dailySchedules = [];
  const suspensionVisits = [];
  const scheduleImplantation = {};

  // eslint-disable-next-line no-unused-vars
  for (const padVisit of padVisits) {
    const CLIENT_RESPONSABILITY = USER_TYPE.HOMECARE;
    const { responsibleType, visitationType, padVisitType, previousEvents } = padVisit;

    const visitationTypeTemplate = visitationType.visitationTypeTemplate;

    const isPadVisitSuspension = padVisitType === PAD_VISIT_TYPE.SUSPENSION;
    const isResponsibleClient = responsibleType === CLIENT_RESPONSABILITY;
    const visitTypeId = visitationTypeTemplate.id;
    const isImplantationVisit = visitTypeId === VISITATION_TYPE_TEMPLATE.IMPLANTATION;

    if (!isPadVisitSuspension) {
      //
      if (isResponsibleClient && !isImplantationVisit) {
        // TODO uncomment to enable dailyFrequecy
        const isDailyFrequency = checkDailySchedule(padVisit);

        if (isDailyFrequency) {
          dailySchedules.push(buildDailyScheduleObj(padVisit));
        } else {
          genericVisit.push({
            padVisit,
            previousEvents,
            events: [],
            repetition: REPETITION.NONE,
            isMaximumVisitsScheduled: false
            // automaticRepeat: false,
          });
        }
      }
    } else {
      //
      suspensionVisits.push({ padVisitId: padVisit.id });
    }

    if (isResponsibleClient && isImplantationVisit) {
      scheduleImplantation.padVisit = padVisit;
      scheduleImplantation.events = [];
    }
  }

  return { scheduleImplantation, genericVisit, dailySchedules, suspensionVisits };
};
const initialArrayOfClientPrescriptions = pad => {
  const { padPrescriptions } = pad;

  let schedulePrescriptions = [];

  // eslint-disable-next-line no-unused-vars
  for (const padPrescription of padPrescriptions) {
    // const { id, startDateTime, instruction, description } = padPrescription;

    schedulePrescriptions.push({ ...padPrescription });
  }

  return schedulePrescriptions;
};

/**
 * This function builds the initial array of data selected ti client.
 *
 */
const initialArrayOfCooperativeVisits = padVisit => {
  const genericVisit = [];
  // const dailySchedules = [];
  const suspensionVisits = [];

  // eslint-disable-next-line no-unused-vars
  const COOPERATIVE_RESPONSABILITY = USER_TYPE.COOPERATIVE;
  const { padVisitType, responsibleType, previousEvents } = padVisit;

  const isPadVisitSuspension = padVisitType === PAD_VISIT_TYPE.SUSPENSION;

  if (!responsibleType) {
    return { genericVisit, suspensionVisits };
  }

  const isResponsibleCooperative = responsibleType === COOPERATIVE_RESPONSABILITY;

  if (!isPadVisitSuspension) {
    //
    if (isResponsibleCooperative) {
      // TODO uncomment to enable dailyFrequecy
      // const isDailyFreqeuncy = checkDailySchedule(padVisit);

      // if (isDailyFreqeuncy) {
      //   dailySchedules.push(buildDailyScheduleObj(padVisit));
      // } else {
      //   genericVisit.push({
      //     padVisit,
      //     previousEvents,
      //     events: [],
      //     automaticRepeat: false,
      //     isMaximumVisitsScheduled: false
      //   });
      // }

      // TODO comment to enable dailyFrequecy
      genericVisit.push({
        padVisit,
        previousEvents,
        events: [],
        repetition: REPETITION.NONE,
        isMaximumVisitsScheduled: false
        // automaticRepeat: false,
        // dailyAutomaticRepeat: false,
      });
    }
  } else {
    //
    suspensionVisits.push({ padVisitId: padVisit.id });
  }

  return { genericVisit, suspensionVisits };
};

const initialState = () => ({
  loading: false,
  isSubmitting: false,
  padVisitId: null,
  padVisit: {},
  pad: {},
  steps: [],

  selectedData: {
    scheduleImplantation: {
      events: [],
      padVisit: {}
    },
    hospitalReleasePrevision: '',
    dischargePatient: {
      releaseDate: null,
      releaseReasonDescription: null,
      deathReleaseSignal: null
    },
    scheduleVisits: {
      genericVisit: [],
      dailySchedules: []
    },
    schedulePrescriptions: [],
    suspensionVisits: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_CLIENT_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_CLIENT_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    // REFACTOR modificar nome da propriedade selectedData para screenSteps, pois esse objeto representa os dados que cada tela precisa
    // stepScreenData
    case `${TEMPLATE_NAME}_CLIENT_FULFILLED`: {
      const newData = action.payload;
      const { genericVisit, dailySchedules, scheduleImplantation, suspensionVisits } =
        initialArrayOfClientVisits(newData);

      const schedulePrescriptions = initialArrayOfClientPrescriptions(newData);

      return {
        ...state,
        loading: false,
        pad: newData,

        selectedData: {
          scheduleImplantation,
          hospitalReleasePrevision: newData.hospitalReleasePrevision,
          dischargePatient: {
            ...state.selectedData.dischargePatient
          },
          scheduleVisits: {
            genericVisit,
            dailySchedules
          },
          schedulePrescriptions,
          suspensionVisits
        }
      };
    }

    case `${TEMPLATE_NAME}_COOPERATIVE_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_COOPERATIVE_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_COOPERATIVE_FULFILLED`: {
      const newData = action.payload;
      const padVisit = newData;
      const padVisitId = padVisit.id;
      const pad = padVisit.pad;
      const { genericVisit, dailySchedules, suspensionVisits } =
        initialArrayOfCooperativeVisits(padVisit);

      return {
        ...state,
        loading: false,
        pad,
        padVisit,
        padVisitId,

        selectedData: {
          scheduleImplantation: {},
          dischargePatient: pad.hospitalReleasePrevision,
          scheduleVisits: {
            genericVisit,
            dailySchedules
          },
          suspensionVisits
        }
      };
    }

    case `${TEMPLATE_NAME}_SUBMIT_PENDING`: {
      return {
        ...state,
        isSubmitting: true
      };
    }

    case `${TEMPLATE_NAME}_SUBMIT_REJECTED`: {
      return {
        ...state,
        isSubmitting: false
      };
    }

    case `${TEMPLATE_NAME}_SUBMIT_FULFILLED`: {
      return {
        ...state,
        isSubmitting: false
      };
    }

    case `${TEMPLATE_NAME}_SELECT_AND_UPDATE_DATA`: {
      const newData = action.payload;

      const updateGenericVisit = newData.hasOwnProperty('GenericVisit');
      const updateImplantationVisit = newData.hasOwnProperty('ImplantationVisit');

      const { scheduleImplantation } = state.selectedData;
      const { genericVisit } = state.selectedData.scheduleVisits;

      const genericVisitUpdated = updateGenericVisit ? newData.GenericVisit : genericVisit;
      const implantationVisitUpdated = updateImplantationVisit
        ? newData.ImplantationVisit
        : scheduleImplantation;

      const events = !isEmpty(implantationVisitUpdated.events)
        ? implantationVisitUpdated.events
        : [];

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          scheduleVisits: {
            ...state.selectedData.scheduleVisits,
            genericVisit: [...genericVisitUpdated]
          },
          scheduleImplantation: {
            ...state.selectedData.scheduleImplantation,
            events
          }
        }
      };
    }

    // case `${TEMPLATE_NAME}_AUTOMATIC_REPETITION`: {
    //   const padVisit = action.payload;
    //   const { genericVisit } = state.selectedData.scheduleVisits;
    //   const genericVisitUpdated = updateAutomaticRepeat(padVisit, genericVisit);

    //   return {
    //     ...state,
    //     selectedData: {
    //       ...state.selectedData,
    //       scheduleVisits: {
    //         ...state.selectedData.scheduleVisits,
    //         genericVisit: [...genericVisitUpdated]
    //       }
    //     }
    //   };
    // }

    // case `${TEMPLATE_NAME}_DAILY_AUTOMATIC_REPETITION`: {
    //   const padVisit = action.payload;
    //   const { genericVisit } = state.selectedData.scheduleVisits;
    //   const updatedGenericVisits = dailyUpdateAutomaticRepeat(padVisit, genericVisit);

    //   return {
    //     ...state,
    //     selectedData: {
    //       ...state.selectedData,
    //       scheduleVisits: {
    //         ...state.selectedData.scheduleVisits,
    //         genericVisit: [...updatedGenericVisits]
    //       }
    //     }
    //   };
    // }

    case `${TEMPLATE_NAME}_CHANGE_REPETITION`: {
      const { repetition, padVisit } = action.payload;
      const { genericVisit } = state.selectedData.scheduleVisits;

      const genericVisitUpdated = updateRepetition({ padVisit, genericVisit, repetition });

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          scheduleVisits: {
            ...state.selectedData.scheduleVisits,
            genericVisit: [...genericVisitUpdated]
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_CLEAR_SCHEDULE`: {
      const padVisit = action.payload;
      const { genericVisit } = state.selectedData.scheduleVisits;
      const clearedGenericVisits = clearSchedule(padVisit, genericVisit);

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          scheduleVisits: {
            ...state.selectedData.scheduleVisits,
            genericVisit: [...clearedGenericVisits]
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_SCHEDULE_MAXIMUM_VISITS`: {
      const { padVisit, isMaximumVisitsScheduled } = action.payload;
      const { genericVisit } = state.selectedData.scheduleVisits;
      const genericVisitUpdated = updateScheduledMaximumVisits(
        padVisit,
        genericVisit,
        isMaximumVisitsScheduled
      );

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          scheduleVisits: {
            ...state.selectedData.scheduleVisits,
            genericVisit: [...genericVisitUpdated]
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_UPDATE_SCHEDULE_PRESCRIPTION`: {
      const { payload: schedulePrescriptions } = action;

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          schedulePrescriptions
        }
      };
    }

    case `${TEMPLATE_NAME}_HOSPITAL_DISCHARGE`: {
      const hospitalReleasePrevision = action.payload;

      const { scheduleVisits } = state.selectedData;
      const dailySchedules = _.cloneDeep(scheduleVisits.dailySchedules);

      const dailyScheduleImpl = new DailySchedule(dailySchedules);

      const newDailySchedules =
        dailyScheduleImpl.changeFromHospitalDischarge(hospitalReleasePrevision);

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          hospitalReleasePrevision,
          scheduleVisits: {
            ...state.selectedData.scheduleVisits,
            dailySchedules: [...newDailySchedules]
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_DISCHARGE_PATIENT`: {
      const dischargePatient = action.payload;
      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          dischargePatient
        }
      };
    }

    case `${TEMPLATE_NAME}_INITIALIZATION_STEPS`: {
      const steps = action.payload;
      return {
        ...state,
        steps
      };
    }

    case `${TEMPLATE_NAME}_DAILY_SCHEDULE_FORM_CHANGE`: {
      const { padVisit, dailyScheduleForm } = _.cloneDeep(action.payload);

      const { selectedData } = _.cloneDeep(state);
      const { scheduleVisits } = selectedData;
      const { dailySchedules } = scheduleVisits;

      const dailyScheduleImpl = new DailySchedule(dailySchedules);

      const updatedDailySchedule = dailyScheduleImpl.changeFromForm(dailyScheduleForm, padVisit);

      return {
        ...state,
        selectedData: {
          ...selectedData,
          scheduleVisits: {
            ...scheduleVisits,
            dailySchedules: updatedDailySchedule
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_DAILY_SCHEDULE_PROFESSIONAL_NAME_CHANGE`: {
      const { padVisit, code, professionalName } = action.payload;

      const { selectedData } = state;
      const { scheduleVisits } = selectedData;
      const { dailySchedules } = scheduleVisits;

      return {
        ...state,
        selectedData: {
          ...selectedData,
          scheduleVisits: {
            ...scheduleVisits,
            dailySchedules: [...dailySchedules].map(dailySchedule => {
              if (dailySchedule.padVisit.id !== padVisit.id) return { ...dailySchedule };

              const { schedulingEvents } = dailySchedule;

              return {
                ...dailySchedule,
                schedulingEvents: [...schedulingEvents].map(schedulingEvent => {
                  if (schedulingEvent.code !== code) return { ...schedulingEvent };

                  return {
                    ...schedulingEvent,
                    professionalName
                  };
                })
              };
            })
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_DAILY_SCHEDULE_FORM_ADD`: {
      const padVisit = _.cloneDeep(action.payload);
      const dailyScheduleForm = buildDailyScheduleFormVisit();

      const { selectedData } = _.cloneDeep(state);
      const { scheduleVisits } = _.cloneDeep(selectedData);
      const { dailySchedules } = _.cloneDeep(scheduleVisits);

      const updatedDailySchedule = dailySchedules.map(dailySchedule => {
        if (dailySchedule.padVisit.id !== padVisit.id) return dailySchedule;

        return {
          ...dailySchedule,
          schedulingEvents: [...dailySchedule.schedulingEvents, dailyScheduleForm]
        };
      });

      return {
        ...state,
        selectedData: {
          ...selectedData,
          scheduleVisits: {
            ...scheduleVisits,
            dailySchedules: updatedDailySchedule
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_DAILY_SCHEDULE_FORM_REMOVE`: {
      const { padVisitId, schedulingEventCode } = action.payload;

      const { selectedData } = _.cloneDeep(state);
      const { scheduleVisits } = _.cloneDeep(selectedData);
      const { dailySchedules } = _.cloneDeep(scheduleVisits);

      const updatedDailySchedule = dailySchedules.map(dailySchedule => {
        if (dailySchedule.padVisit.id !== padVisitId) return dailySchedule;

        return {
          ...dailySchedule,
          schedulingEvents: dailySchedule.schedulingEvents.filter(
            event => event.code !== schedulingEventCode
          )
        };
      });

      return {
        ...state,
        selectedData: {
          ...selectedData,
          scheduleVisits: {
            ...scheduleVisits,
            dailySchedules: updatedDailySchedule
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
